// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_button-container__O2vAE {
  width: fit-content;
  position: relative;
  display: flex;
  align-items: center;
}
.Button_button-container__block__j4s7t {
  width: 100%;
}
.Button_button-container__block__j4s7t .Button_button-container__button__B\\+jMH {
  width: 100%;
}
.Button_button-container__block__j4s7t .Button_button-container__button__B\\+jMH .Button_button-title__zo2Jv {
  justify-content: center;
}
.Button_button-container__button__B\\+jMH {
  padding: 0 12px;
  font-size: 14px;
  font-weight: 400;
  color: var(--ds-text);
  background-color: transparent;
  border-radius: var(--m-border-radius);
  text-decoration: none;
  cursor: pointer;
  border: 1.5px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  position: relative;
  transition: 0.2s ease-in-out;
  -webkit-user-select: none;
  user-select: none;
}
.Button_button-container__button__B\\+jMH.Button_button-text--default__89zp\\+ {
  height: 2.3744rem;
}
.Button_button-container__button__B\\+jMH.Button_button-text--default__89zp\\+ .Button_use-icon__Crd4a {
  font-size: 18px;
}
.Button_button-container__button__B\\+jMH.Button_button-text--small__afV87 {
  height: 32px;
}
.Button_button-container__button__B\\+jMH.Button_button-text--small__afV87 .Button_use-icon__Crd4a {
  font-size: 16px;
}
.Button_button-container__button__B\\+jMH.Button_button-text--medium__FDOV1 {
  height: 42px;
}
.Button_button-container__button__B\\+jMH.Button_button-text--medium__FDOV1 .Button_use-icon__Crd4a {
  font-size: 20px;
}
.Button_button-container__button__B\\+jMH.Button_button-text--large__rronP {
  height: 52px;
}
.Button_button-container__button__B\\+jMH.Button_button-text--large__rronP .Button_use-icon__Crd4a {
  font-size: 24px;
}
.Button_button-container__button__B\\+jMH.Button_button-icon__g7Pnn {
  display: flex;
  align-items: center;
  justify-content: center;
}
.Button_button-container__button__B\\+jMH.Button_button-icon--circle__VuTWy {
  border-radius: 50%;
}
.Button_button-container__button__B\\+jMH.Button_button-icon--square__drUxI {
  border-radius: 4px;
}
.Button_button-container__button__B\\+jMH.Button_button-icon--default__3sDRG {
  width: 2.3744rem;
  height: 2.3744rem;
  font-size: 18px;
}
.Button_button-container__button__B\\+jMH.Button_button-icon--small__6Yr3o {
  width: 32px;
  height: 32px;
  font-size: 16px;
}
.Button_button-container__button__B\\+jMH.Button_button-icon--medium__6J2dq {
  width: 42px;
  height: 42px;
  font-size: 20px;
}
.Button_button-container__button__B\\+jMH.Button_button-icon--large__WZiiA {
  width: 52px;
  height: 52px;
  font-size: 24px;
}
.Button_button-container__button__B\\+jMH .Button_button-title__zo2Jv {
  display: flex;
}
.Button_button-container__button__B\\+jMH.Button_default__RiyKR {
  background-color: #f1f2f4;
}
.Button_button-container__button__B\\+jMH.Button_default__RiyKR:hover {
  background-color: var(--m-subtle);
}
.Button_button-container__button__B\\+jMH.Button_default__RiyKR:active {
  background-color: var(--m-subtle-bolder);
}
.Button_button-container__button__B\\+jMH.Button_primary__y\\+Gql {
  background-color: var(--m-background-primary);
}
.Button_button-container__button__B\\+jMH.Button_primary__y\\+Gql .Button_button-title__zo2Jv {
  color: var(--m-white);
}
.Button_button-container__button__B\\+jMH.Button_primary__y\\+Gql .Button_use-icon__Crd4a {
  color: var(--m-white);
}
.Button_button-container__button__B\\+jMH.Button_primary__y\\+Gql:hover {
  background-color: var(--m-background-primary-hovered);
}
.Button_button-container__button__B\\+jMH.Button_primary__y\\+Gql:active {
  background-color: var(--m-background-primary-pressed);
}
.Button_button-container__button__B\\+jMH.Button_warning__-vTJc {
  background-color: var(--m-background-warning);
}
.Button_button-container__button__B\\+jMH.Button_warning__-vTJc .Button_button-title__zo2Jv {
  color: var(--m-text);
}
.Button_button-container__button__B\\+jMH.Button_warning__-vTJc .Button_use-icon__Crd4a {
  color: var(--m-white);
}
.Button_button-container__button__B\\+jMH.Button_warning__-vTJc:hover {
  background-color: var(--m-background-warning-hovered);
}
.Button_button-container__button__B\\+jMH.Button_warning__-vTJc:active {
  background-color: var(--m-background-warning-pressed);
}
.Button_button-container__button__B\\+jMH.Button_danger__Dci2l {
  background-color: var(--m-background-danger);
}
.Button_button-container__button__B\\+jMH.Button_danger__Dci2l .Button_button-title__zo2Jv {
  color: var(--m-white);
}
.Button_button-container__button__B\\+jMH.Button_danger__Dci2l .Button_use-icon__Crd4a {
  color: var(--m-white);
}
.Button_button-container__button__B\\+jMH.Button_danger__Dci2l:hover {
  background-color: var(--m-background-danger-hovered);
}
.Button_button-container__button__B\\+jMH.Button_danger__Dci2l:active {
  background-color: var(--m-background-danger-pressed);
}
.Button_button-container__button__B\\+jMH.Button_subtle__aNQG2 {
  color: var(--m-text);
}
.Button_button-container__button__B\\+jMH.Button_subtle__aNQG2:hover {
  background-color: #f1f2f4;
}
.Button_button-container__button__B\\+jMH.Button_subtle__aNQG2:active {
  background-color: var(--m-subtle-card-background-color);
}
.Button_button-container__button__B\\+jMH.Button_link__\\+ihKB {
  color: var(--m-primary);
}
.Button_button-container__button__B\\+jMH.Button_link__\\+ihKB:hover {
  text-decoration: underline;
  color: var(--m-primary-bolder);
}
.Button_button-container__button__B\\+jMH.Button_link__\\+ihKB:active {
  color: var(--m-primary-xbolder);
}
.Button_button-container__button__B\\+jMH.Button_subtle-link__j45-I {
  color: #44546f;
}
.Button_button-container__button__B\\+jMH.Button_subtle-link__j45-I:hover {
  text-decoration: underline !important;
}
.Button_button-container__button__B\\+jMH.Button_danger-subtle__aNiYN {
  background-color: var(--m-background-subtle-danger);
  color: var(--m-background-danger);
}
.Button_button-container__button__B\\+jMH.Button_danger-subtle__aNiYN:hover {
  background-color: var(--m-background-subtle-danger-hovered);
}
.Button_button-container__button__B\\+jMH.Button_danger-subtle__aNiYN:active {
  background-color: var(--m-background-subtle-danger-pressed);
}
.Button_button-container__button__B\\+jMH.Button_primary-subtle__MpoAP {
  background-color: var(--m-background-subtle-primary);
  color: #00b4f3;
}
.Button_button-container__button__B\\+jMH.Button_primary-subtle__MpoAP:hover {
  background-color: var(--m-background-subtle-primary-hovered);
}
.Button_button-container__button__B\\+jMH.Button_primary-subtle__MpoAP:active {
  background-color: var(--m-background-subtle-primary-pressed);
}
.Button_button-container__button__B\\+jMH.Button_warning-subtle__rhG18 {
  background-color: var(--m-background-subtle-warning);
  color: #ffc501;
}
.Button_button-container__button__B\\+jMH.Button_neutral__Faxnf {
  border: 1px solid var(--m-subtle-bolder);
  white-space: nowrap;
  transition: box-shadow 0.5s ease;
}
.Button_button-container__button__B\\+jMH.Button_neutral__Faxnf:hover {
  box-shadow: 0 3px 8px rgba(9, 30, 66, 0.15);
}
.Button_button-container__button__B\\+jMH.Button_primary-animated__XJSoP {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #00b4f3 0%, #008fc9 100%);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.25s ease, opacity 0.2s ease;
  position: relative;
  overflow: hidden;
  justify-content: center;
  box-shadow: none;
}
.Button_button-container__button__B\\+jMH.Button_primary-animated__XJSoP .Button_button-title__zo2Jv {
  color: white;
  font-weight: 500;
  letter-spacing: 0.3px;
  font-size: 13px;
}
.Button_button-container__button__B\\+jMH.Button_primary-animated__XJSoP .Button_use-icon__Crd4a {
  color: white;
  font-size: 14px;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  position: relative;
}
.Button_button-container__button__B\\+jMH.Button_primary-animated__XJSoP::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.16) 0%, transparent 50%);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}
.Button_button-container__button__B\\+jMH.Button_primary-animated__XJSoP:hover {
  background: linear-gradient(135deg, #00a6e0 0%, #007db4 100%);
  box-shadow: none;
}
.Button_button-container__button__B\\+jMH.Button_primary-animated__XJSoP:hover::before {
  transform: translateX(100%);
}
.Button_button-container__button__B\\+jMH.Button_primary-animated__XJSoP:active {
  background: linear-gradient(135deg, #0099d1 0%, #0070a3 100%);
  box-shadow: none;
}
.Button_button-container__button__B\\+jMH.Button_primary-animated__XJSoP:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
  pointer-events: none;
}
.Button_button-container__button__B\\+jMH.Button_primary-animated__XJSoP.Button_loading__oVwtO {
  pointer-events: none;
  opacity: 0.8;
}
.Button_button-container__button__B\\+jMH.Button_primary-animated__XJSoP.Button_loading__oVwtO .Button_use-icon__Crd4a {
  animation: Button_spin__k0X9x 1s linear infinite;
}
.Button_button-container__button__B\\+jMH.Button_primary-animated__XJSoP.Button_success__npeQo {
  background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%);
}
.Button_button-container__button__B\\+jMH.Button_primary-animated__XJSoP.Button_success__npeQo .Button_use-icon__Crd4a {
  transform: scale(1.2);
}
@keyframes Button_spin__k0X9x {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .Button_button-container__button__B\\+jMH.Button_primary-animated__XJSoP {
    flex-direction: row;
    width: 100%;
    justify-content: center;
    padding: 12px 16px;
  }
  .Button_button-container__button__B\\+jMH.Button_primary-animated__XJSoP .Button_button-title__zo2Jv {
    font-size: 0.875rem;
  }
}

.Button_disabled-default__BaUXi:disabled, .Button_button-container__button__B\\+jMH.Button_primary__y\\+Gql:disabled, .Button_button-container__button__B\\+jMH.Button_warning__-vTJc:disabled {
  cursor: pointer;
  pointer-events: none;
  background-color: #e3e3e1 !important;
}
.Button_disabled-default__BaUXi:disabled *, .Button_button-container__button__B\\+jMH.Button_primary__y\\+Gql:disabled *, .Button_button-container__button__B\\+jMH.Button_warning__-vTJc:disabled * {
  color: #929292 !important;
}

.Button_disabled-outline__GqEQg:disabled {
  cursor: pointer;
  pointer-events: none;
  border-color: #e3e3e1 !important;
}
.Button_disabled-outline__GqEQg:disabled * {
  color: #929292 !important;
}

[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_default__RiyKR {
  background-color: rgba(255, 255, 255, 0.07);
}
[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_default__RiyKR .Button_button-title__zo2Jv {
  color: var(--m-text);
}
[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_primary__y\\+Gql {
  color: #162949;
}
[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_primary__y\\+Gql .Button_button-title__zo2Jv,
[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_primary__y\\+Gql .Button_use-icon__Crd4a {
  color: #162949;
}
[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_warning__-vTJc {
  color: #162949;
}
[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_warning__-vTJc .Button_button-title__zo2Jv,
[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_warning__-vTJc .Button_use-icon__Crd4a {
  color: #162949;
}
[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_danger__Dci2l {
  color: #162949;
}
[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_danger__Dci2l .Button_button-title__zo2Jv,
[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_danger__Dci2l .Button_use-icon__Crd4a {
  color: #162949;
}
[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_subtle__aNQG2:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_subtle-link__j45-I {
  color: var(--m-text);
}
[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_subtle-link__j45-I .Button_button-title__zo2Jv {
  color: var(--m-text);
}
[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_link__\\+ihKB:hover {
  color: #2d82f7;
}
[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_neutral__Faxnf {
  border-color: var(--m-border-color);
}
[m-data-theme=dark] .Button_button-container__button__B\\+jMH.Button_neutral__Faxnf:hover {
  background-color: var(--m-subtle-card-background-color);
}`, "",{"version":3,"sources":["webpack://./src/components/BaseUI/Button/Button.module.scss"],"names":[],"mappings":"AAAA;EAGE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AACF;AACE;EACE,WAAA;AACJ;AACI;EACE,WAAA;AACN;AACM;EACE,uBAAA;AACR;AAIE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EAEA,qBAAA;EACA,6BAAA;EACA,qCAAA;EACA,qBAAA;EACA,eAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,4BAAA;EACA,yBAAA;EAGA,iBAAA;AAHJ;AAMM;EACE,iBAAA;AAJR;AAMQ;EACE,eAAA;AAJV;AAQM;EACE,YAAA;AANR;AAQQ;EACE,eAAA;AANV;AAUM;EACE,YAAA;AARR;AAUQ;EACE,eAAA;AARV;AAYM;EACE,YAAA;AAVR;AAYQ;EACE,eAAA;AAVV;AAeI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAbN;AAeM;EACE,kBAAA;AAbR;AAgBM;EACE,kBAAA;AAdR;AAiBM;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;AAfR;AAkBM;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAhBR;AAmBM;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAjBR;AAoBM;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAlBR;AAsBI;EACE,aAAA;AApBN;AAuBI;EACE,yBAAA;AArBN;AAuBM;EACE,iCAAA;AArBR;AAwBM;EACE,wCAAA;AAtBR;AA0BI;EACE,6CAAA;AAxBN;AA0BM;EACE,qBAAA;AAxBR;AA2BM;EACE,qBAAA;AAzBR;AA4BM;EACE,qDAAA;AA1BR;AA6BM;EACE,qDAAA;AA3BR;AAiCI;EACE,6CAAA;AA/BN;AAiCM;EACE,oBAAA;AA/BR;AAkCM;EACE,qBAAA;AAhCR;AAmCM;EACE,qDAAA;AAjCR;AAoCM;EACE,qDAAA;AAlCR;AAwCI;EACE,4CAAA;AAtCN;AAwCM;EACE,qBAAA;AAtCR;AAyCM;EACE,qBAAA;AAvCR;AA0CM;EACE,oDAAA;AAxCR;AA2CM;EACE,oDAAA;AAzCR;AA6CI;EACE,oBAAA;AA3CN;AA6CM;EACE,yBAAA;AA3CR;AA8CM;EACE,uDAAA;AA5CR;AAgDI;EACE,uBAAA;AA9CN;AAgDM;EACE,0BAAA;EACA,8BAAA;AA9CR;AAiDM;EACE,+BAAA;AA/CR;AAmDI;EACE,cAAA;AAjDN;AAmDM;EACE,qCAAA;AAjDR;AAoDI;EACE,mDAAA;EACA,iCAAA;AAlDN;AAmDM;EACE,2DAAA;AAjDR;AAmDM;EACE,2DAAA;AAjDR;AAoDI;EACE,oDAAA;EACA,cAAA;AAlDN;AAmDM;EACE,4DAAA;AAjDR;AAmDM;EACE,4DAAA;AAjDR;AAoDI;EACE,oDAAA;EACA,cAAA;AAlDN;AAoDI;EACE,wCAAA;EACA,mBAAA;EACA,gCAAA;AAlDN;AAoDM;EACE,2CAAA;AAlDR;AAsDI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EAEA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EAGA,eAAA;EACA,oDAAA;EACA,kBAAA;EACA,gBAAA;EAEA,uBAAA;EACA,gBAAA;AAxDN;AA0DM;EACE,YAAA;EACA,gBAAA;EACA,qBAAA;EAEA,eAAA;AAzDR;AA4DM;EACE,YAAA;EACA,eAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA1DR;AA6DM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kFAAA;EAKA,4BAAA;EACA,+BAAA;AA/DR;AAkEM;EACE,6DAAA;EACA,gBAAA;AAhER;AAmEM;EACE,2BAAA;AAjER;AAoEM;EACE,6DAAA;EACA,gBAAA;AAlER;AAqEM;EACE,YAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAnER;AAuEM;EACE,oBAAA;EACA,YAAA;AArER;AAuEQ;EACE,gDAAA;AArEV;AA0EM;EACE,6DAAA;AAxER;AA0EQ;EACE,qBAAA;AAxEV;AA4EM;EACE;IACE,uBAAA;EA1ER;EA4EM;IACE,yBAAA;EA1ER;AACF;AA8EM;EAzGF;IA0GI,mBAAA;IACA,WAAA;IACA,uBAAA;IACA,kBAAA;EA3EN;EA6EM;IACE,mBAAA;EA3ER;AACF;;AAkFE;EACE,eAAA;EACA,oBAAA;EACA,oCAAA;AA/EJ;AAiFI;EACE,yBAAA;AA/EN;;AAqFE;EACE,eAAA;EACA,oBAAA;EACA,gCAAA;AAlFJ;AAoFI;EACE,yBAAA;AAlFN;;AA0FM;EACE,2CAAA;AAvFR;AAyFQ;EACE,oBAAA;AAvFV;AA2FM;EACE,cAAA;AAzFR;AA2FQ;;EAEE,cAAA;AAzFV;AA6FM;EACE,cAAA;AA3FR;AA6FQ;;EAEE,cAAA;AA3FV;AA+FM;EACE,cAAA;AA7FR;AA+FQ;;EAEE,cAAA;AA7FV;AAkGQ;EACE,0CAAA;AAhGV;AAoGM;EACE,oBAAA;AAlGR;AAoGQ;EACE,oBAAA;AAlGV;AAuGQ;EACE,cAAA;AArGV;AAyGM;EACE,mCAAA;AAvGR;AAyGQ;EACE,uDAAA;AAvGV","sourcesContent":[".button-container {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  &__block {\n    width: 100%;\n\n    .button-container__button {\n      width: 100%;\n\n      .button-title {\n        justify-content: center;\n      }\n    }\n  }\n\n  &__button {\n    padding: 0 12px;\n    font-size: 14px;\n    font-weight: 400;\n    // font-family: \"Roboto\";\n    color: var(--ds-text);\n    background-color: transparent;\n    border-radius: var(--m-border-radius);\n    text-decoration: none;\n    cursor: pointer;\n    border: 1.5px solid transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    position: relative;\n    transition: 0.2s ease-in-out;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n\n    &.button-text {\n      &--default {\n        height: 2.3744rem;\n\n        .use-icon {\n          font-size: 18px;\n        }\n      }\n\n      &--small {\n        height: 32px;\n\n        .use-icon {\n          font-size: 16px;\n        }\n      }\n\n      &--medium {\n        height: 42px;\n\n        .use-icon {\n          font-size: 20px;\n        }\n      }\n\n      &--large {\n        height: 52px;\n\n        .use-icon {\n          font-size: 24px;\n        }\n      }\n    }\n\n    &.button-icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      &--circle {\n        border-radius: 50%;\n      }\n\n      &--square {\n        border-radius: 4px;\n      }\n\n      &--default {\n        width: 2.3744rem;\n        height: 2.3744rem;\n        font-size: 18px;\n      }\n\n      &--small {\n        width: 32px;\n        height: 32px;\n        font-size: 16px;\n      }\n\n      &--medium {\n        width: 42px;\n        height: 42px;\n        font-size: 20px;\n      }\n\n      &--large {\n        width: 52px;\n        height: 52px;\n        font-size: 24px;\n      }\n    }\n\n    .button-title {\n      display: flex;\n    }\n\n    &.default {\n      background-color: #f1f2f4;\n\n      &:hover {\n        background-color: var(--m-subtle);\n      }\n\n      &:active {\n        background-color: var(--m-subtle-bolder);\n      }\n    }\n\n    &.primary {\n      background-color: var(--m-background-primary);\n\n      .button-title {\n        color: var(--m-white);\n      }\n\n      .use-icon {\n        color: var(--m-white);\n      }\n\n      &:hover {\n        background-color: var(--m-background-primary-hovered);\n      }\n\n      &:active {\n        background-color: var(--m-background-primary-pressed);\n      }\n\n      @extend .disabled-default;\n    }\n\n    &.warning {\n      background-color: var(--m-background-warning);\n\n      .button-title {\n        color: var(--m-text);\n      }\n\n      .use-icon {\n        color: var(--m-white);\n      }\n\n      &:hover {\n        background-color: var(--m-background-warning-hovered);\n      }\n\n      &:active {\n        background-color: var(--m-background-warning-pressed);\n      }\n\n      @extend .disabled-default;\n    }\n\n    &.danger {\n      background-color: var(--m-background-danger);\n\n      .button-title {\n        color: var(--m-white);\n      }\n\n      .use-icon {\n        color: var(--m-white);\n      }\n\n      &:hover {\n        background-color: var(--m-background-danger-hovered);\n      }\n\n      &:active {\n        background-color: var(--m-background-danger-pressed);\n      }\n    }\n\n    &.subtle {\n      color: var(--m-text);\n\n      &:hover {\n        background-color: #f1f2f4;\n      }\n\n      &:active {\n        background-color: var(--m-subtle-card-background-color);\n      }\n    }\n\n    &.link {\n      color: var(--m-primary);\n\n      &:hover {\n        text-decoration: underline;\n        color: var(--m-primary-bolder);\n      }\n\n      &:active {\n        color: var(--m-primary-xbolder);\n      }\n    }\n\n    &.subtle-link {\n      color: #44546f;\n\n      &:hover {\n        text-decoration: underline !important;\n      }\n    }\n    &.danger-subtle {\n      background-color: var(--m-background-subtle-danger);\n      color: var(--m-background-danger);\n      &:hover {\n        background-color: var(--m-background-subtle-danger-hovered);\n      }\n      &:active {\n        background-color: var(--m-background-subtle-danger-pressed);\n      }\n    }\n    &.primary-subtle {\n      background-color: var(--m-background-subtle-primary);\n      color: #00b4f3;\n      &:hover {\n        background-color: var(--m-background-subtle-primary-hovered);\n      }\n      &:active {\n        background-color: var(--m-background-subtle-primary-pressed);\n      }\n    }\n    &.warning-subtle {\n      background-color: var(--m-background-subtle-warning);\n      color: #ffc501;\n    }\n    &.neutral {\n      border: 1px solid var(--m-subtle-bolder);\n      white-space: nowrap;\n      transition: box-shadow 0.5s ease;\n\n      &:hover {\n        box-shadow: 0 3px 8px rgba(9, 30, 66, 0.15);\n      }\n    }\n\n    &.primary-animated {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      //   padding: 2px 8px;\n      background: linear-gradient(135deg, #00b4f3 0%, #008fc9 100%);\n      color: white;\n      border: none;\n      border-radius: 6px;\n      //   font-size: 0.8rem;\n      //   font-weight: 500;\n      cursor: pointer;\n      transition: background 0.25s ease, opacity 0.2s ease;\n      position: relative;\n      overflow: hidden;\n      //   min-width: 90px;\n      justify-content: center;\n      box-shadow: none;\n\n      .button-title {\n        color: white;\n        font-weight: 500;\n        letter-spacing: 0.3px;\n        // text-transform: uppercase;\n        font-size: 13px;\n      }\n\n      .use-icon {\n        color: white;\n        font-size: 14px;\n        transition: transform 0.3s ease;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 18px;\n        height: 18px;\n        position: relative;\n      }\n\n      &::before {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(\n          135deg,\n          rgba(255, 255, 255, 0.16) 0%,\n          transparent 50%\n        );\n        transform: translateX(-100%);\n        transition: transform 0.6s ease;\n      }\n\n      &:hover {\n        background: linear-gradient(135deg, #00a6e0 0%, #007db4 100%);\n        box-shadow: none;\n      }\n\n      &:hover::before {\n        transform: translateX(100%);\n      }\n\n      &:active {\n        background: linear-gradient(135deg, #0099d1 0%, #0070a3 100%);\n        box-shadow: none;\n      }\n\n      &:disabled {\n        opacity: 0.7;\n        cursor: not-allowed;\n        transform: none;\n        pointer-events: none;\n      }\n\n      // Loading state\n      &.loading {\n        pointer-events: none;\n        opacity: 0.8;\n\n        .use-icon {\n          animation: spin 1s linear infinite;\n        }\n      }\n\n      // Success state\n      &.success {\n        background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%);\n\n        .use-icon {\n          transform: scale(1.2);\n        }\n      }\n\n      @keyframes spin {\n        from {\n          transform: rotate(0deg);\n        }\n        to {\n          transform: rotate(360deg);\n        }\n      }\n\n      // Responsive design for mobile\n      @media (max-width: 768px) {\n        flex-direction: row;\n        width: 100%;\n        justify-content: center;\n        padding: 12px 16px;\n\n        .button-title {\n          font-size: 0.875rem;\n        }\n      }\n    }\n  }\n}\n\n.disabled-default {\n  &:disabled {\n    cursor: pointer;\n    pointer-events: none;\n    background-color: #e3e3e1 !important;\n\n    * {\n      color: #929292 !important;\n    }\n  }\n}\n\n.disabled-outline {\n  &:disabled {\n    cursor: pointer;\n    pointer-events: none;\n    border-color: #e3e3e1 !important;\n\n    * {\n      color: #929292 !important;\n    }\n  }\n}\n\n[m-data-theme=\"dark\"] {\n  .button-container {\n    &__button {\n      &.default {\n        background-color: rgba($color: #fff, $alpha: 0.07);\n\n        .button-title {\n          color: var(--m-text);\n        }\n      }\n\n      &.primary {\n        color: #162949;\n\n        .button-title,\n        .use-icon {\n          color: #162949;\n        }\n      }\n\n      &.warning {\n        color: #162949;\n\n        .button-title,\n        .use-icon {\n          color: #162949;\n        }\n      }\n\n      &.danger {\n        color: #162949;\n\n        .button-title,\n        .use-icon {\n          color: #162949;\n        }\n      }\n\n      &.subtle {\n        &:hover {\n          background-color: rgba($color: #fff, $alpha: 0.1);\n        }\n      }\n\n      &.subtle-link {\n        color: var(--m-text);\n\n        .button-title {\n          color: var(--m-text);\n        }\n      }\n\n      &.link {\n        &:hover {\n          color: #2d82f7;\n        }\n      }\n\n      &.neutral {\n        border-color: var(--m-border-color);\n\n        &:hover {\n          background-color: var(--m-subtle-card-background-color);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button-container": `Button_button-container__O2vAE`,
	"button-container__block": `Button_button-container__block__j4s7t`,
	"button-container__button": `Button_button-container__button__B+jMH`,
	"button-title": `Button_button-title__zo2Jv`,
	"button-text--default": `Button_button-text--default__89zp+`,
	"use-icon": `Button_use-icon__Crd4a`,
	"button-text--small": `Button_button-text--small__afV87`,
	"button-text--medium": `Button_button-text--medium__FDOV1`,
	"button-text--large": `Button_button-text--large__rronP`,
	"button-icon": `Button_button-icon__g7Pnn`,
	"button-icon--circle": `Button_button-icon--circle__VuTWy`,
	"button-icon--square": `Button_button-icon--square__drUxI`,
	"button-icon--default": `Button_button-icon--default__3sDRG`,
	"button-icon--small": `Button_button-icon--small__6Yr3o`,
	"button-icon--medium": `Button_button-icon--medium__6J2dq`,
	"button-icon--large": `Button_button-icon--large__WZiiA`,
	"default": `Button_default__RiyKR`,
	"primary": `Button_primary__y+Gql`,
	"warning": `Button_warning__-vTJc`,
	"danger": `Button_danger__Dci2l`,
	"subtle": `Button_subtle__aNQG2`,
	"link": `Button_link__+ihKB`,
	"subtle-link": `Button_subtle-link__j45-I`,
	"danger-subtle": `Button_danger-subtle__aNiYN`,
	"primary-subtle": `Button_primary-subtle__MpoAP`,
	"warning-subtle": `Button_warning-subtle__rhG18`,
	"neutral": `Button_neutral__Faxnf`,
	"primary-animated": `Button_primary-animated__XJSoP`,
	"loading": `Button_loading__oVwtO`,
	"spin": `Button_spin__k0X9x`,
	"success": `Button_success__npeQo`,
	"disabled-default": `Button_disabled-default__BaUXi`,
	"disabled-outline": `Button_disabled-outline__GqEQg`
};
export default ___CSS_LOADER_EXPORT___;
